<app-complex-formulas
  [showCard]="false"
></app-complex-formulas>
